(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
jQuery(function($) {
    $('.CarouselList').flickity({
      "wrapAround": true,
	  "pageDots": false,
	  "autoPlay": 3000,
      "cellAlign": 'left',
      "draggable": false
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-with-image-carousel"] && !Shopify.designMode) return;
  try {
    
jQuery(function($) {
    $('.Content--CarouselList').flickity({
      "wrapAround": true,
      "prevNextButtons": false,
	  "pageDots": true,
	  "autoPlay": 3000,
      "cellAlign": 'left',
      "draggable": false
    });
});

  } catch(e) { console.error(e); }
})();
})();
